import gql from 'graphql-tag'
import api from './apiClient'

export default {
  readAllByEmisor: emisor =>
    api
      .send({
        query: gql`
          query READ_ALL($emisor: ID!) {
            Entrada {
              readAllByEmisor(emisor: $emisor) {
                _id
                tipo
                causa
                cuentaContable
              }
            }
          }
        `,
        variables: {
          emisor
        }
      })
      .then(result => result.data.data.Entrada.readAllByEmisor),

  create: input =>
    api
      .send({
        query: gql`
          mutation CREATE($input: EntradaInput!) {
            Entrada {
              create(input: $input) {
                _id
              }
            }
          }
        `,
        variables: {
          input
        }
      })
      .then(result => result.data.data.Entrada.create),

  entrada: (input, accounting) =>
    api
      .send({
        query: gql`
          mutation ENTRADA($input: ControlMermaInput!, $accounting: Boolean) {
            Entrada {
              entrada(input: $input, accounting: $accounting)
            }
          }
        `,
        variables: {
          input,
          accounting
        }
      })
      .then(result => result.data.data.Entrada.entrada),

  delete: input =>
    api
      .send({
        query: gql`
          mutation delete($input: [ID!]!) {
            Entrada {
              delete(input: $input) {
                _id
                state
                message
              }
            }
          }
        `,
        variables: { input }
      })
      .then(result => result.data.data.Entrada.delete)
}
